<template>
	<div>
		<app-eye-doc-stepper step="3"></app-eye-doc-stepper>

		<v-container>
			<v-card :loading="loading">
				<v-card-title primary-title>
					<div class="title">Patient Medical Information page</div>
				</v-card-title>
				<v-card-text>
					<v-banner v-if="patient" sticky single-line>
						<span
							class="pl-12"
						>{{ patient.id }} - {{ patient.name }} - {{ patient.gender }} - {{ patient.age }}</span>
					</v-banner>
					<v-form v-if="questions.length" v-model="valid">
						<app-questionnaire
							v-model="answers"
							:questions="questions"
							:appointment-id="appointmentId"
							:doc-id="docId"
						></app-questionnaire>

						<v-row v-if="questions.length" justify="center" dense>
							<v-col class="text-center" cols="12">
								<v-btn color="primary" class="text-none mx-1" :disabled="!valid" @click="submit">Save</v-btn>
								<v-btn color="error" class="text-none mx-1" outlined @click="goToHome">Cancel</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-container>

		<v-overlay :value="submitting">
			<v-card light class="text-center">
				<v-card-title primary-title>
					<div>Saving...</div>
				</v-card-title>
				<v-card-text style="min-width: 300px">
					<template v-for="(prog, index) in progresses">
						<div v-if="prog != null" :key="index" class="py-2">
							<v-progress-linear
								:value="prog"
								:color="prog == '100' ? 'green' : 'primary'"
								height="10"
								rounded
								striped
							></v-progress-linear>
						</div>
					</template>

					<div class="pt-2">
						<v-progress-linear
							v-if="overallProgress != null"
							:value="overallProgress"
							:color="overallProgress == '100' ? 'green' : 'primary'"
							height="15"
							rounded
							striped
						></v-progress-linear>
					</div>
				</v-card-text>
			</v-card>
		</v-overlay>
	</div>
</template>

<script>
const axios = require("axios");

export default {
	components: {
		"app-eye-doc-stepper": require("@/components/steppers/AppEyeDocStepper.vue")
			.default,
		"app-questionnaire": require("@/components/AppQuestionnaire.vue")
			.default
	},
	mixins: [
		require("@/mixins/backend-mixin").default,
		require("@/mixins/router-mixin").default,
		require("@/mixins/rules-mixin").default,
		require("@/mixins/utilities-mixin").default
	],
	data: () => ({
		patient: null,
		questions: [],
		valid: false,
		answers: [],
		appointmentId: null,
		docId: null,
		loading: true,
		submitting: false,
		progresses: [null, null, null, null],
		overallProgress: 0,
		updater: null
	}),
	async mounted() {
		this.appointmentId = this.$route.params.appointmentId;
		this.docId = await this.$store.state.userInfo.nationalId;
		await this.getPatientInfo();

		await this.getQuestions();
	},
	methods: {
		async getPatientInfo() {
			var id = this.$route.params.appointmentId;

			const url = this.BACKEND_URL + "/api/getAppointmentById/" + id;
			const thisVue = this;

			axios
				.get(url)
				.then(response => {
					console.log(response);
					if (response.status == 200) {
						thisVue.patient = response.data.user;
						thisVue.patient.id = thisVue.patient.nationalId;
						thisVue.patient.name =
							thisVue.patient.FirstName +
							" " +
							thisVue.patient.FatherName +
							" " +
							thisVue.patient.FamilyName;
						thisVue.patient.age =
							thisVue.getAge(thisVue.patient.birth) + " Years";
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		goToHome() {
			this.$router.push("/new-appointment");
		},
		async getQuestions() {
			const stage = 3;
			const url =
				this.BACKEND_URL + "/api/getStageDiagnosisType/" + stage;

			const thisVue = this;

			axios
				.get(url)
				.then(response => {
					if (response.status == 200) {
						var questions = response.data.data;

						thisVue.questions = questions;
						thisVue.loading = false;
					}
				})
				.catch(error => {
					console.error(error);
				});
		},
		submit() {
			this.updater = setInterval(() => {
				this.$forceUpdate();
			}, 500);

			this.submitting = true;
			this.submitAll();
		},
		async submitAll() {
			var answers = this.answers;
			const thisVue = this;

			answers = answers.map(answer => {
				// remove duration
				var newAnswer = {
					appointmentId: answer.appointmentId,
					docId: answer.docId,
					result: answer.result,
					note: answer.note,
					file: answer.file,
					relatedResult: answer.relatedResult
				};

				return newAnswer;
			});

			var index = -1;

			var promises = await answers.map(async function(answer) {
				// upload images
				var newAnswer;
				if (answer.file) {
					index++;
					var imgPath = await thisVue.uploadImage(
						answer.file,
						answer.result,
						index
					);

					newAnswer = {
						appointmentId: answer.appointmentId,
						docId: answer.docId,
						result: answer.result,
						note: imgPath,
						relatedResult: answer.relatedResult
					};
				} else {
					newAnswer = {
						appointmentId: answer.appointmentId,
						docId: answer.docId,
						result: answer.result,
						note: answer.note,
						relatedResult: answer.relatedResult
					};
				}

				return newAnswer;
			});

			await Promise.all(promises).then(async completed => {
				console.log("completed");
				answers = await completed;
			});

			console.log(answers);

			const url = this.BACKEND_URL + "/api/storeArrayDignosisResult";

			var data = {
				array: answers
			};

			let config = {
				onUploadProgress: function(progressEvent) {
					var percentCompleted = Math.round(
						(progressEvent.loaded * 100) / progressEvent.total
					);

					thisVue.overallProgress = percentCompleted;
				}
			};

			axios
				.post(url, data, config)
				.then(response => {
					thisVue.$store.dispatch("triggerPushNotification", {
						message: response.data
					});
					thisVue.submitting = false;
					clearInterval(thisVue.updater);
					thisVue.goToHome();
				})
				.catch(error => {
					thisVue.$store.dispatch("triggerPushNotification", {
						message: error.response.data
					});
				});
		},
		async uploadImage(image, result, index) {
			const url = this.BACKEND_URL + "/api/uploadImg";

			const thisVue = this;

			var data = new FormData();
			data.append("img", image);
			data.append("appointmentId", this.appointmentId);
			data.append("result", result);

			this.progresses[index] = 0;

			let config = {
				headers: {
					"Content-Type": "multipart/form-data; boundary=something"
				},
				onUploadProgress: function(progressEvent) {
					var percentCompleted = Math.round(
						(progressEvent.loaded * 100) / progressEvent.total
					);

					thisVue.progresses[index] = percentCompleted;
				}
			};

			let filepath = "";

			await axios
				.post(url, data, config)
				.then(response => {
					console.log(response);
					filepath = response.data;
					console.log(filepath);
				})
				.catch(error => {
					thisVue.$store.dispatch("triggerPushNotification", {
						message: error.response.data
					});
				});

			return filepath;
		}
	}
};
</script>

<style scoped>
.v-banner__wrapper {
	padding-left: 8px !important;
}
</style>
